<template>
  <v-app id="app-formulario">
    <v-app-bar class="title-home" app hide-on-scroll dark color="transparent" elevation="0" >
    
        <h3 class="text-h4 black--text">
          <span style="text-transform: capitalize;" class="font-weight-black">{{ nivel }}</span> - {{ grado }} - Clave de pre-registro
          <span v-text="` ` + id_solicitud"></span>
        </h3>
   
    </v-app-bar>
    <v-main class="main-home">
      <v-stepper v-model="paso" class="elevation-0 transparent" >
        <v-stepper-header class="white mx-3 rounded">
          <v-stepper-step :complete="paso > 1" step="1" 
            >Datos Aspirante</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="paso > 2" step="2"
            >Datos Familiares</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="paso > 3" step="3"
            >Encuesta</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="paso > 4" step="4"
            >Documentación</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :complete="paso > 5" step="5"
            >Completada</v-stepper-step
          >
        </v-stepper-header>
        <v-stepper-items>
          <v-stepper-content step="1" class="steep-datos-tab">
            <DatosAspirante
              v-if="paso === 1"
              @emit-next="next"
              @emit-salir="salir"
            />
          </v-stepper-content>
          <v-stepper-content step="2" class="steep-datos-tab">
            <DatosFamiliares
              v-if="paso === 2"
              @emit-salir="salir"
              @emit-next="next"
              @emit-last="last"
            />
          </v-stepper-content>
          <v-stepper-content step="3" class="steep-datos-tab">
            <Encuesta
              v-if="paso === 3"
              @emit-salir="salir"
              @emit-next="next"
              @emit-last="last"
            />
          </v-stepper-content>
          <v-stepper-content step="4" class="steep-datos-tab">
            <Documentacion
              v-if="paso === 4"
              @emit-salir="salir"
              @emit-next="next"
              @emit-last="last"
            />
          </v-stepper-content>
          <v-stepper-content step="5" class="steep-datos-tab">
            <Completada @emit-last="last" />
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-main>
  </v-app>
</template>
<script setup>
import { onMounted, ref , getCurrentInstance } from 'vue';
import DatosAspirante from "@/subview/formulario/DatosAspirante";
import DatosFamiliares from "@/subview/formulario/DatosFamiliares";
import Encuesta from "@/subview/formulario/Encuesta";
import Documentacion from "@/subview/formulario/Documentacion";
import Completada from "@/subview/formulario/Completada";


    const root=getCurrentInstance()?.proxy

    console.log('root',root)
    
    const title=ref("Formulario")
    const paso=ref(0)
    // Nivel, grado y clave de solicitud
    const id_solicitud=ref(0)
    const nivel=ref('')
    const nivelColor=ref('')
    const grado=ref('')


  onMounted(()=>{
    paso.value = root.$ls.get("paso", 1);
    id_solicitud.value = root.$ls.get("folio", 0);
    nivel.value = root.$ls.get("nivelNombre", "Nivel seleccionado");
    nivelColor.value = root.$ls.get("nivelColor", "Nivel seleccionado");
    grado.value = root.$ls.get("gradoNombre", "Grado seleccionado");
  })

    function salir() {
      root.$ls.clear();
      root.$router.replace({ name: "Home" });
    }

    function next(paso_payload) {
      paso.value = paso_payload;
      root.$ls.set("paso", paso_payload);
    }

    function last(paso_payload) {
      paso.value = paso_payload;
      root.$ls.set("paso", paso_payload);
    }

    function msj(paso_payload) {}

  
</script>

<style scoped>

@media (max-width: 600px) {
.title-home{

  
  height: 70px!important;
  background-color: white!important;
}

.title-home  h3{
  /* background-color: red; */
  /* height: 100%;
  width: 100%; */
  text-align: center;
  font-size: 1.2rem!important;
  /* display: flex; */
  /* justify-content: center; */
}

  .main-home{
    margin-top: 20px;
  }

  .steep-datos-tab{
    /* background-color: red; */
    height: calc(100vh - 150px);
    overflow-y: auto;
  }
}
</style>